var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useMemo } from 'react';
import { Spin, Input } from 'antd';
import { useParams } from 'react-router-dom';
import Header from 'components/Header';
import useTeamAddPermission from 'apollo/mutations/Teams/TEAM_ADD_PERMISSION';
import useTeamDeletePermission from 'apollo/mutations/Teams/TEAM_DELETE_PERMISSION';
import { usePermissionsQuery } from 'apollo/queries/Teams/TEAM_PERMISSIONS';
import { PageContainer } from 'ui/styled';
import { PERMISSION_CATEGORIES } from 'constants/permissionCategories';
import { PermissionCategoryCard } from './components/PermissionCategoryCard';
import { PermissionsWrapper, SearchContainer, ResultsCount, CategoriesContainer } from './styled';
var Search = Input.Search;
var Permissions = function () {
    var _a, _b;
    var id = useParams().id;
    var _c = useState(''), searchTerm = _c[0], setSearchTerm = _c[1];
    var _d = usePermissionsQuery({
        variables: { id: id !== null && id !== void 0 ? id : '' },
        skip: !id
    }), data = _d.data, loading = _d.loading;
    var _e = useTeamAddPermission('Team Permission Added'), teamAddPermission = _e.onMutate, addPermissionLoading = _e.loading;
    var _f = useTeamDeletePermission(), teamDeletePermission = _f.onMutate, deletePermissionLoading = _f.loading;
    var onPermissionsUpdate = function (value, item) { return __awaiter(void 0, void 0, void 0, function () {
        var variables;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!id)
                        return [2 /*return*/];
                    variables = {
                        id: id,
                        permission: item
                    };
                    if (!value) return [3 /*break*/, 2];
                    return [4 /*yield*/, teamAddPermission(variables)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, teamDeletePermission(variables)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var filteredCategories = useMemo(function () {
        if (!searchTerm.trim())
            return PERMISSION_CATEGORIES;
        var lowerSearch = searchTerm.toLowerCase();
        return PERMISSION_CATEGORIES.map(function (category) { return (__assign(__assign({}, category), { permissions: category.permissions.filter(function (perm) {
                var haystack = [
                    perm.label,
                    perm.description,
                    perm.primaryPermissionLabel,
                    perm.primaryDescription,
                    perm.secondaryPermissionLabel,
                    perm.secondaryDescription,
                    perm.tertiaryPermissionLabel,
                    perm.tertiaryDescription
                ];
                return haystack.some(function (field) {
                    return field === null || field === void 0 ? void 0 : field.toLowerCase().includes(lowerSearch);
                });
            }) })); }).filter(function (category) { return category.permissions.length > 0; });
    }, [searchTerm]);
    var totalPermissions = PERMISSION_CATEGORIES.reduce(function (sum, cat) { return sum + cat.permissions.length; }, 0);
    var visiblePermissions = filteredCategories.reduce(function (sum, cat) { return sum + cat.permissions.length; }, 0);
    var activePermissions = ((_a = data === null || data === void 0 ? void 0 : data.team) === null || _a === void 0 ? void 0 : _a.permissions) || [];
    var mutationLoading = addPermissionLoading || deletePermissionLoading;
    return (_jsxs(_Fragment, { children: [_jsx(Header, { title: ((_b = data === null || data === void 0 ? void 0 : data.team) === null || _b === void 0 ? void 0 : _b.name) ? "".concat(data.team.name, " - Permissions") : 'Permissions', loading: loading }), _jsx(PageContainer, { children: _jsx(Spin, { spinning: loading || mutationLoading, children: _jsxs(PermissionsWrapper, { children: [_jsx(SearchContainer, { children: _jsx(Search, { placeholder: "Search permissions...", value: searchTerm, onChange: function (e) { return setSearchTerm(e.target.value); }, allowClear: true, size: "large" }) }), searchTerm && searchTerm.trim() && (_jsxs(ResultsCount, { children: ["Showing ", visiblePermissions, " of ", totalPermissions, " permissions"] })), _jsx(CategoriesContainer, { children: filteredCategories.map(function (category) { return (_jsx(PermissionCategoryCard, { categoryId: category.id, categoryName: category.name, categoryDescription: category.description, permissions: category.permissions, activePermissions: activePermissions, onPermissionChange: onPermissionsUpdate, loading: mutationLoading }, category.id)); }) })] }) }) })] }));
};
export default Permissions;
